<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-users" /> 用戶資料管理
    </h4>
    <b-tabs pills v-model="activeTab">
      <!-- Tab: customer -->
      <b-tab v-if="ability.can('read', 'setting_customers')" lazy>
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-user-tie"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">客戶</span>
        </template>

        <customers-list class="" />
      </b-tab>
      <!-- Tab: staff-->
      <b-tab v-if="ability.can('read', 'setting_staffs')" lazy>
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">員工</span>
        </template>

        <staffs-list class="" />
      </b-tab>
      <!-- Tab: supplier-->
      <b-tab v-if="ability.can('read', 'setting_suppliers')" lazy>
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">服務供應商</span>
        </template>

        <suppliers-list class="" />
      </b-tab> 
      <!-- Tab: user-->
      <b-tab v-if="false">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-user"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">帳戶</span>
        </template>
        <users-list class="" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import customersList from "./customer/customers-list/customersList.vue";
import staffsList from "./staff/staffs-list/staffsList.vue";
import suppliersList from "./supplier/suppliers-list/suppliersList.vue";
import UsersList from "./user/users-list/UsersList.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    customersList,
    staffsList,
    suppliersList,
    UsersList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
    
  },
  data(){
    return {
      activeTab: 0, // Initialize with 0
      ability
    }
  },
  watch: {
    activeTab(newTab, oldTab) {
      console.log({ newTab, oldTab });
      if (oldTab !== null) {
        localStorage.setItem('activeTab', newTab);
      }
    },
  },
  created() {
    const storedTab = Number(localStorage.getItem('activeTab'));
    this.activeTab = storedTab !== null ? Number(storedTab) : 0;
  },
  setup() {},
};
</script>
